import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function Facility(props) {
  var base = new Base()
  const momentNow = moment()
  const [arr, setArr] = useState([])

  useEffect(() => {
    get_data()
  }, [])

  async function get_data() {
    var response = await base.request(base.url_api + "/facility")

    if (response != null) {
      if (response.status == "success") {
        for (let data of response.data) {
          data.image = data.url_image
        }
        setArr(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  return (
    <section className="resturant-one">
      <div className="container">
        <div className="row gutter-y-30">
          
          {
            arr.map((data, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="resturent-card wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='100ms'>
                  <div className="resturent-card__image">
                    <img src={data.url_image} alt="Best Hotel Service" />
                    <div className="resturent-card__image__group">
                      <span className="resturent-card__image__hover resturent-card__image__hover--1"></span>
                      <span className="resturent-card__image__hover resturent-card__image__hover--2"></span>
                      <span className="resturent-card__image__hover resturent-card__image__hover--3"></span>
                      <span className="resturent-card__image__hover resturent-card__image__hover--4"></span>
                      <span className="resturent-card__image__hover resturent-card__image__hover--5"></span>
                    </div>
                  </div>
                  <div className="resturent-card__content">
                    <div className="resturent-card__icon" style={{ fontSize: '1.4rem', }}>
                      <i className="icon-tray"></i>
                    </div>
                    <h3 className="resturent-card__title" style={{ fontSize: '1rem', }}>{data.title}</h3>
                  </div>
                </div>
              </div>
            ))
          }
          
        </div>
      </div>
    </section>
  );
};
